import images from "./images";
import { FaRing } from "react-icons/fa";

const About = {
  sub: "About Us",
  heading: "Your Dream Wedding, Perfectly Planned",
  description: [ "Welcome to EverAfter Events, your premier wedding planning service. We are passionate about creating unforgettable experiences, tailored to your unique love story. With over a decade of experience in designing and organizing beautiful weddings, our team is here to ensure every detail of your special day is executed flawlessly, from start to finish." ],
  experience: {
    year: '15+',
    text: "years of experience",
    icon: <FaRing />,
  },
  points: [
    "Personalized Wedding Planning",
    "Experienced Event Coordination",
    "Creative Design and Decor",
    "Trusted Vendor Partnerships"
  ],
  image: {
    src1: images.about1,
    src2: images.about2,
    alt1: "Wedding Image 1",
    alt2: "Wedding Image 2"
  },
  button: {
    text: "Contact Us",
    link: "Contact-us"
  }
};

export default About;